import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import SelectedFieldsList from "views/components/widgets/SelectedFieldsList";
import FieldSelect from "views/components/aggregationwizard/FieldSelect";
const FIELD_LIST_LIMIT = 1;
const ToggleButton = styled(Button)`
  padding: 0;
  margin-bottom: 10px;
  display: block;
`;
const ToggleIcon = styled(Icon)`
  margin-left: 5px;
`;
const FieldsConfiguration = ({
  createSelectPlaceholder = void 0,
  displaySortableListOverlayInPortal = false,
  onChange,
  isFieldQualified = void 0,
  selectSize = void 0,
  selectedFields,
  showSelectAllRest = false,
  showDeSelectAll = false,
  showListCollapseButton = false,
  showUnit = false,
  fieldSelect: FieldSelectComponent = FieldSelect,
  allowCreate = false
}) => {
  const { t } = useTranslation("widgets");
  const [showSelectedList, setShowSelectedList] = useState(true);
  const selectPlaceholder = createSelectPlaceholder != null ? createSelectPlaceholder : t("fields_configuration.add_field");
  const onAddField = useCallback(
    (newField) => onChange([...selectedFields, newField]),
    [onChange, selectedFields]
  );
  const _showListCollapseButton = showListCollapseButton && selectedFields.length > FIELD_LIST_LIMIT;
  const onSelectAllRest = (newFields) => {
    const _selectedFields = [...selectedFields, ...newFields];
    onChange(_selectedFields);
    if (showListCollapseButton && _selectedFields.length > FIELD_LIST_LIMIT) {
      setShowSelectedList(false);
    }
  };
  const onDeselectAll = () => {
    onChange([]);
    setShowSelectedList(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, _showListCollapseButton && /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      bsStyle: "link",
      bsSize: "xs",
      onClick: () => {
        setShowSelectedList((cur) => !cur);
      }
    },
    showSelectedList ? t("fields_configuration.hide_selected", { count: selectedFields.length }) : t("fields_configuration.show_selected", { count: selectedFields.length }),
    /* @__PURE__ */ React.createElement(ToggleIcon, { name: showSelectedList ? "keyboard_arrow_up" : "keyboard_arrow_down" })
  ), showSelectedList && /* @__PURE__ */ React.createElement(
    SelectedFieldsList,
    {
      selectedFields,
      selectSize,
      displayOverlayInPortal: displaySortableListOverlayInPortal,
      onChange,
      fieldSelect: FieldSelectComponent,
      showUnit,
      allowCreate
    }
  ), /* @__PURE__ */ React.createElement(
    FieldSelectComponent,
    {
      id: "field-create-select",
      onChange: onAddField,
      clearable: false,
      isFieldQualified,
      persistSelection: false,
      name: "field-create-select",
      value: void 0,
      size: selectSize,
      excludedFields: selectedFields != null ? selectedFields : [],
      placeholder: selectPlaceholder,
      ariaLabel: selectPlaceholder,
      onSelectAllRest: showSelectAllRest && onSelectAllRest,
      showSelectAllRest,
      onDeSelectAll: onDeselectAll,
      showDeSelectAll: showDeSelectAll && !!selectedFields.length,
      allowCreate
    }
  ));
};
export default FieldsConfiguration;
